<div mat-dialog-title="">
  <div class="flex justify-between items-center flex-row flex-wrap gap-[1rem]">
    <h3 class="mat-h2 m0" translate="">Documents</h3>
  </div>
</div>
<form [formGroup]="documentFormGroup">
  <mat-dialog-content class="flex flex-col">
    <div class="flex flex-col w-full">
      <mat-form-field appearance="outline">
        <mat-label translate="">Link to application</mat-label>
        <mat-select formControlName="application" required="">
          @for (application of applicationsAll; track application) {
            <mat-option [value]="application">
              {{application.name}} - {{application.mortgage?.lender?.name}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

    </div>
  </mat-dialog-content>
  <mat-dialog-actions class="flex flex-row justify-start items-center gap-[1rem]">
    <unite-loading-button [text]="'Save' | translate" [loading]="loadingSave" (buttonClick)="save()">
    </unite-loading-button>
    <button type="button" mat-button="" mat-dialog-close="">
      <span translate="">
        Cancel
      </span>
    </button>
  </mat-dialog-actions>
</form>
